import React from "react";

import ArticleContent from "../blog/article-content";
import { AnnouncementType } from "@/@types/Annoucement";

type Props = {
  announcement: AnnouncementType;
};

const AnnouncementMain = ({ announcement }: Props) => {
  return (
    <ArticleContent
      classes={{}}
      article={{
        title: announcement.title,
        imagePath: announcement.imagePath,
        date: announcement.date,
        subtitle: announcement.subtitle,
        content: announcement.content,
        author: announcement.author,
        authorPhotoPath: announcement.authorPhotoPath,
      }}
    />
  );
};

export default AnnouncementMain;
